import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from ".";
import MapsCombobox from "../MapsCombobox";
import CheckboxField from "./CheckboxField";
import InputField from "./InputField";
import MonthField from "./MonthField";
import NumberField from "./NumberField";
import RadioCardField from "./RadioCardField";
import RangeField from "./RangeField";
import SelectField from "./SelectField";
import SwitchField from "./SwitchField";
import ToggleButtonField from "./ToggleButtonField";

export interface DynamicFormFieldProps<T extends FieldValues> {
  fieldDefinition: FormFieldDefinition<T>;
  control: Control<T>;
  onSubmit: VoidFunction;
  autoFocus?: boolean;
}

const DynamicFormField = <T extends FieldValues>({
  fieldDefinition,
  control,
  onSubmit,
  autoFocus,
}: DynamicFormFieldProps<T>) => {
  if (fieldDefinition.component === "TOGGLE_BUTTON") {
    return (
      <ToggleButtonField
        control={control}
        fieldDefinition={fieldDefinition}
        onSubmit={onSubmit}
      />
    );
  } else if (fieldDefinition.component === "SWITCH") {
    return <SwitchField control={control} fieldDefinition={fieldDefinition} />;
  } else if (fieldDefinition.component === "NUMBER_INPUT") {
    return <NumberField control={control} fieldDefinition={fieldDefinition} />;
  } else if (fieldDefinition.component === "SELECT") {
    return <SelectField control={control} fieldDefinition={fieldDefinition} />;
  } else if (fieldDefinition.component === "MONTH") {
    return <MonthField control={control} fieldDefinition={fieldDefinition} />;
  } else if (fieldDefinition.component === "RADIO_CARD") {
    return (
      <RadioCardField control={control} fieldDefinition={fieldDefinition} />
    );
  } else if (fieldDefinition.component === "RANGE") {
    return <RangeField control={control} fieldDefinition={fieldDefinition} />;
  } else if (fieldDefinition.component === "MAPS_COMBOBOX") {
    return <MapsCombobox {...fieldDefinition} control={control} />;
  } else if (fieldDefinition.component === "CHECKBOX") {
    return (
      <CheckboxField control={control} fieldDefinition={fieldDefinition} />
    );
  }
  return (
    <InputField
      autoFocus={autoFocus}
      control={control}
      fieldDefinition={fieldDefinition}
    />
  );
};

export default DynamicFormField;
